/**
 * Fills `:0` … `:9` in a translation with `args`, in one pass over the template. Replacing one
 * index at a time rescans what an earlier index inserted: a time "08:11" given as `:0` had its ":1"
 * overwritten by the second argument, and "klo 08:11 · 8" came out as "klo 0881 · 8".
 *
 * An index is one digit, as it always was: "(starting from :05)" in the Sheet means `:0` then "5"
 * ("€5"). An index past the end of `args` stays as written.
 */
export const interpolate = (text: string, args: string[] = []): string =>
  // `String()` rather than `??`: a caller passing undefined got "undefined" before, and this change
  // is about rescanning only, not about what a missing value prints.
  text.replace(/:(\d)/g, (match, index: string) => (Number(index) < args.length ? String(args[Number(index)]) : match))
